import React, { useEffect, type PropsWithChildren } from 'react';
import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { fg } from '@atlassian/jira-feature-gating';
import { ADVANCED, type Tabs } from '../../../common/constants.tsx';

const styles = cssMap({
	container: {
		display: 'flex',
		height: '422px',
		width: '600px',
	},
	advancedContainer: {
		width: '480px',
	},
	containerWithTabs: {
		display: 'flex',
		width: '600px',
	},
});

export const FilterPopupContainer = ({
	children,
	isModeSwitcherEnabled = false,
	activeTab,
	updatePopup,
}: PropsWithChildren<{
	isModeSwitcherEnabled?: boolean;
	activeTab?: Tabs;
	updatePopup: () => void;
}>) => {
	const isAdvanced = activeTab === ADVANCED;

	// We need to update the popup position when dimensions change
	useEffect(() => {
		isModeSwitcherEnabled && fg('list_lovability_improving_filters') && updatePopup();
	}, [updatePopup, isAdvanced, isModeSwitcherEnabled]);

	return (
		<Box
			xcss={cx(
				isModeSwitcherEnabled && fg('list_lovability_improving_filters')
					? styles.containerWithTabs
					: styles.container,
				isModeSwitcherEnabled &&
					isAdvanced &&
					fg('list_lovability_improving_filters') &&
					styles.advancedContainer,
			)}
		>
			{children}
		</Box>
	);
};
